





















import Vue from 'vue';

/**
 * A wrapper around the `v-alert` vuetify component
 */
export default Vue.extend({
  name: 'SAlert',
  props: {
    /**
     * The alert type. success, info, warning or error
     */
    type: {
      type: String,
      required: true,
    },
    /**
     * Controls visibility
     */
    value: {
      type: Boolean,
      required: true,
    },
    /**
     * Can the user dismiss the message?
     */
    dismissible: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    emitEvent(e) {
      /**
       * Input event fired after a user clicks the dismiss button.
       *
       * @event input
       * @property {boolean}
       */
      this.$emit('input', e);
    },
  },
});
